/**
 * Remediation text for Executive / Diligence "Next:" lines.
 * Prefer `action` (current generate-data field); fall back to legacy `fix`
 * so live packages generated before the rename still render.
 */
export function riskNext(r) {
  if (!r || typeof r !== 'object') return '';
  const text = r.action ?? r.fix;
  return text == null ? '' : String(text);
}
